import { render, staticRenderFns } from "./PurPT_Footer.vue?vue&type=template&id=5b1dafa7"
import script from "./PurPT_Footer.vue?vue&type=script&lang=js"
export * from "./PurPT_Footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports